import {
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  useStore
} from '@nuxtjs/composition-api'

export default function useResizeToDetectMobile(
  context,
  { breakpoint = 992 } = { breakpoint: 992 }
) {
  const store = useStore()

  const hasThrottle = ref(false)
  const PERIOD = 300
  const resizeTime = ref(0)

  onMounted(() => {
    // listen to window resize event
    nextTick(() => {
      onResize()
    })
    window.addEventListener('resize', onResize)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', onResize)
  })

  function onResize() {
    resizeTime.value = new Date()
    if (!hasThrottle.value) {
      hasThrottle.value = true
      resizeThrottle()
    }
  }
  function resizeThrottle() {
    // check if window has been resized again after setTimeout
    if (new Date() - resizeTime.value < PERIOD) {
      setTimeout(resizeThrottle, PERIOD)
    } else {
      const visibleWidth = Math.min(
        window.innerWidth,
        document.documentElement.clientWidth
      )
      store.commit('IS_MOBILE', visibleWidth < breakpoint)
      hasThrottle.value = false
    }
  }
}
